export enum Sizes {
  BIG = 'lg',
  NORMAL = 'md',
  SMALL = 'sm',
  XSMALL = 'xs',
}

export const TitleSizes = {
  XSmall: 'xsmall',
  Small: 'small',
  Medium: 'medium',
  Large: 'large',
} as const

export type TitleSize = (typeof TitleSizes)[keyof typeof TitleSizes]
